import {api} from "../../app/api.js";

export async function ProductView({ product_id }) {
    product_id = parseInt(product_id);

    let product = null;
    let cost = null;

    api.get({
        url: '/products',
        success: response => {
            product = response.products.find((p) => p.id === product_id);

            if (product.cost) {
                cost = '&pound;' + (product.cost / 100).toFixed(2);
            } else {
                cost = 'Free';
            }

            if (!product.image_url) {
                product.image_url = '/public/assets/images/product-default.jpg';
            }

        }, error: () => {
            console.log('Failed to load products');
        }
    })

    return {
        template: `
        <div class="container release">
            <div class="column">
                <div class="artwork" style="padding-top: 2.4rem;">
                    <img src="${product.image_url}" alt="Release Artwork" />
                </div>
            </div>
            <div class="column pad details">
                <h1 class="title">${product.name}</h1>
                <p class="description">
                    ${product.description}
                </p>
                <div class="empty"></div>
                <button id="BuyButton">Buy Now</button>
                <button id="AddToBasket">Add To Basket</button>
            </div>
            <p class="price">${cost}</p>
        </div>
      `,
        async onMount() {
            // Do Nothing
        }
    };
}